package org.multipaz.doctypes.generated

/**
 * Generated strings for language: ja
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_ja = mapOf(
    "age_verification_attribute_older_than_years" to "{age}歳以上",
    "age_verification_description_older_than_years" to "mDL保持者が{age}歳以上であるかを示す情報",
    "age_verification_request_age_over_18" to "18歳以上",
    "age_verification_request_age_over_18_zkp" to "18歳以上 (ZKP)",
    "age_verification_request_age_over_21" to "21歳以上",
    "age_verification_request_age_over_21_zkp" to "21歳以上 (ZKP)",
    "age_verification_request_all_data_elements" to "すべてのデータ要素",
    "document_display_name_age_verification" to "年齢確認",
    "document_display_name_driving_license" to "運転免許証",
    "document_display_name_eu_personal_id" to "身分証明書",
    "document_display_name_google_wallet_id_pass" to "Google ウォレット IDパス",
    "document_display_name_photo_id" to "顔写真付き身分証明書",
    "document_display_name_vaccination_document" to "予防接種証明書",
    "document_display_name_vehicle_registration" to "車両登録",
    "driving_license_attribute_aamva_version_number" to "AAMVAバージョン番号",
    "driving_license_attribute_administrative_number" to "管理番号",
    "driving_license_attribute_age_in_years" to "年齢（年）",
    "driving_license_attribute_alias_family_name" to "別名（通称）姓",
    "driving_license_attribute_alias_given_name" to "別名（通称）名",
    "driving_license_attribute_alias_suffix" to "別名（通称）接尾辞",
    "driving_license_attribute_audit_information" to "監査情報",
    "driving_license_attribute_biometric_template_face" to "生体認証テンプレート（顔）",
    "driving_license_attribute_biometric_template_fingerprint" to "生体認証テンプレート（指紋）",
    "driving_license_attribute_biometric_template_iris" to "生体認証テンプレート（虹彩）",
    "driving_license_attribute_biometric_template_signature_sign" to "生体認証テンプレート（署名・サイン）",
    "driving_license_attribute_compliance_type" to "適合種類",
    "driving_license_attribute_date_of_birth" to "生年月日",
    "driving_license_attribute_date_of_expiry" to "有効期限",
    "driving_license_attribute_date_of_issue" to "発行日",
    "driving_license_attribute_domestic_driving_privileges" to "国内運転資格",
    "driving_license_attribute_driving_privileges" to "運転資格",
    "driving_license_attribute_edl_indicator" to "EDL区分",
    "driving_license_attribute_eye_color" to "目の色",
    "driving_license_attribute_family_name" to "姓",
    "driving_license_attribute_family_name_national_characters" to "姓（自国文字）",
    "driving_license_attribute_family_name_truncation" to "姓の省略",
    "driving_license_attribute_given_name_national_characters" to "名（自国文字）",
    "driving_license_attribute_given_name_truncation" to "名の省略",
    "driving_license_attribute_given_names" to "名",
    "driving_license_attribute_hair_color" to "髪の色",
    "driving_license_attribute_hazmat_endorsement_expiration_date" to "HAZMAT認可期限",
    "driving_license_attribute_height" to "身長",
    "driving_license_attribute_issuing_authority" to "発行機関",
    "driving_license_attribute_issuing_country" to "発行国",
    "driving_license_attribute_issuing_jurisdiction" to "発行管轄区域",
    "driving_license_attribute_license_number" to "免許証番号",
    "driving_license_attribute_limited_duration_document_indicator" to "期間限定書類区分",
    "driving_license_attribute_name_suffix" to "氏名接尾辞",
    "driving_license_attribute_nationality" to "国籍",
    "driving_license_attribute_older_than_13" to "13歳以上",
    "driving_license_attribute_older_than_16" to "16歳以上",
    "driving_license_attribute_older_than_18" to "18歳以上",
    "driving_license_attribute_older_than_21" to "21歳以上",
    "driving_license_attribute_older_than_25" to "25歳以上",
    "driving_license_attribute_older_than_60" to "60歳以上",
    "driving_license_attribute_older_than_62" to "62歳以上",
    "driving_license_attribute_older_than_65" to "65歳以上",
    "driving_license_attribute_older_than_68" to "68歳以上",
    "driving_license_attribute_organ_donor" to "臓器提供者",
    "driving_license_attribute_photo_of_holder" to "顔写真",
    "driving_license_attribute_place_of_birth" to "出生地",
    "driving_license_attribute_portrait_image_timestamp" to "顔写真撮影日時",
    "driving_license_attribute_race_ethnicity" to "人種・民族",
    "driving_license_attribute_resident_address" to "住所",
    "driving_license_attribute_resident_city" to "居住市",
    "driving_license_attribute_resident_country" to "居住国",
    "driving_license_attribute_resident_county" to "居住郡",
    "driving_license_attribute_resident_postal_code" to "居住郵便番号",
    "driving_license_attribute_resident_state" to "居住州",
    "driving_license_attribute_sex" to "性別",
    "driving_license_attribute_signature_usual_mark" to "署名 / 慣用サイン",
    "driving_license_attribute_un_distinguishing_sign" to "国連識別記号",
    "driving_license_attribute_veteran" to "退役軍人",
    "driving_license_attribute_weight" to "体重",
    "driving_license_attribute_weight_range" to "重量範囲",
    "driving_license_attribute_year_of_birth" to "生年",
    "driving_license_description_aamva_version_number" to "AAMVA mDLデータ要素セットのバージョンを識別する番号",
    "driving_license_description_administrative_number" to "発行機関により割り当てられる監査管理番号",
    "driving_license_description_age_in_years" to "mDL保持者の年齢",
    "driving_license_description_alias_family_name" to "クレデンシャル保持者が知られているその他の姓。",
    "driving_license_description_alias_given_name" to "クレデンシャル保持者の別名。",
    "driving_license_description_alias_suffix" to "クレデンシャル保持者が知られているその他の接尾辞。",
    "driving_license_description_audit_information" to "資格情報が最初にプロビジョニングされた日時、場所、担当者を識別する英数字の文字列",
    "driving_license_description_biometric_template_face" to "mDL保持者の顔生体情報",
    "driving_license_description_biometric_template_fingerprint" to "mDL保持者の指紋",
    "driving_license_description_biometric_template_iris" to "mDL保持者の虹彩",
    "driving_license_description_biometric_template_signature_sign" to "mDL保持者の署名/サイン",
    "driving_license_description_compliance_type" to "コンプライアンスを示すDHS必須フィールド。",
    "driving_license_description_date_of_birth" to "mDL保持者の生年月日。不明の場合はおおよその生年月日。",
    "driving_license_description_date_of_expiry" to "mDLの有効期限",
    "driving_license_description_date_of_issue" to "mDLの発行日",
    "driving_license_description_domestic_driving_privileges" to "免許保持者が運転を許可されている車種",
    "driving_license_description_driving_privileges" to "mDL保持者の運転免許区分",
    "driving_license_description_edl_indicator" to "クレデンシャルがEDLである場合に表示されます。",
    "driving_license_description_eye_color" to "mDL保持者の目の色",
    "driving_license_description_family_name" to "mDL保持者の姓、または主要識別子。",
    "driving_license_description_family_name_national_characters" to "mDL保持者の姓",
    "driving_license_description_family_name_truncation" to "フィールドが切り詰められたかどうかを示すコード",
    "driving_license_description_given_name_national_characters" to "mDL保持者の名",
    "driving_license_description_given_name_truncation" to "名またはミドルネームが切り詰められたかどうかを示すコード",
    "driving_license_description_given_names" to "mDL保持者の名、または副次的識別子。",
    "driving_license_description_hair_color" to "mDL保持者の髪の色",
    "driving_license_description_hazmat_endorsement_expiration_date" to "文書によって付与された危険物取扱者認定が失効する日付。",
    "driving_license_description_height" to "mDL保持者の身長（cm）",
    "driving_license_description_issuing_authority" to "発行機関名",
    "driving_license_description_issuing_country" to "ISO 3166-1で定義された、発行機関の国または地域のAlpha-2国コード。",
    "driving_license_description_issuing_jurisdiction" to "mDL発行管轄区域の国細区分コード。",
    "driving_license_description_license_number" to "発行機関により付与または算出される番号",
    "driving_license_description_limited_duration_document_indicator" to "クレデンシャル保持者の一時的な合法的在留資格を示すDHS必須フィールド。1: 一時的な合法的在留資格",
    "driving_license_description_name_suffix" to "運転免許証または身分証明書が発行された個人の氏名接尾辞",
    "driving_license_description_nationality" to "mDL保持者の国籍。",
    "driving_license_description_older_than_13" to "mDL保持者が13歳以上であるかを示す情報",
    "driving_license_description_older_than_16" to "mDL保持者が16歳以上であるかを示す情報",
    "driving_license_description_older_than_18" to "mDL保持者が18歳以上であるかを示す情報",
    "driving_license_description_older_than_21" to "mDL保持者が21歳以上であるかを示す情報",
    "driving_license_description_older_than_25" to "mDL保持者が25歳以上であることの表示。",
    "driving_license_description_older_than_60" to "mDL保持者が60歳以上であることの表示。",
    "driving_license_description_older_than_62" to "mDL保持者が62歳以上であることの表示。",
    "driving_license_description_older_than_65" to "mDL保持者が65歳以上であることの表示。",
    "driving_license_description_older_than_68" to "mDL保持者が68歳以上であることの表示。",
    "driving_license_description_organ_donor" to "資格保持者が臓器提供者であるかどうかを示す指標",
    "driving_license_description_photo_of_holder" to "mDL保持者の顔写真の複製",
    "driving_license_description_place_of_birth" to "mDL保持者の出生国および市区町村または州・県",
    "driving_license_description_portrait_image_timestamp" to "顔写真撮影日",
    "driving_license_description_race_ethnicity" to "カード保持者の人種または民族のコード。",
    "driving_license_description_resident_address" to "mDL保持者の居住地または連絡先（番地、市区町村など）",
    "driving_license_description_resident_city" to "mDL保持者の居住市。",
    "driving_license_description_resident_country" to "mDL保持者が居住する国",
    "driving_license_description_resident_county" to "mDL保持者が居住する郡の3桁の郡コード。",
    "driving_license_description_resident_postal_code" to "mDL保持者の郵便番号。",
    "driving_license_description_resident_state" to "mDL保持者が居住する州/省/地区。",
    "driving_license_description_sex" to "mDL保持者の性別",
    "driving_license_description_signature_usual_mark" to "mDL保持者の署名または慣習的な印の画像",
    "driving_license_description_un_distinguishing_sign" to "発行国の識別標識",
    "driving_license_description_veteran" to "資格保持者が退役軍人であるかどうかを示す指標",
    "driving_license_description_weight" to "mDL保持者の体重（kg）",
    "driving_license_description_weight_range" to "カード保持者のおおよその体重範囲。",
    "driving_license_description_year_of_birth" to "mDL保持者の生年",
    "driving_license_request_age_over_18" to "18歳以上",
    "driving_license_request_age_over_18_and_portrait" to "18歳以上 + 顔写真",
    "driving_license_request_age_over_18_and_portrait_equivalence" to "18歳以上 + 顔写真同等物",
    "driving_license_request_age_over_18_and_portrait_or_portrait_equivalence" to "18歳以上 + (顔写真 または 顔写真同等物)",
    "driving_license_request_age_over_18_zkp" to "18歳以上（ZKP）",
    "driving_license_request_age_over_21" to "21歳以上",
    "driving_license_request_age_over_21_and_portrait" to "21歳以上 + 顔写真",
    "driving_license_request_age_over_21_zkp" to "21歳以上（ZKP）",
    "driving_license_request_all_data_elements" to "すべてのデータ項目",
    "driving_license_request_mandatory_data_elements" to "必須データ項目",
    "driving_license_request_name_and_address_all_stored" to "氏名と住所 (すべて保存済み)",
    "driving_license_request_name_and_address_partially_stored" to "氏名と住所 (一部保存済み)",
    "driving_license_request_us_transportation" to "米国運輸",
    "eu_personal_id_attribute_address" to "住所",
    "eu_personal_id_attribute_age_in_years" to "満年齢",
    "eu_personal_id_attribute_city_of_birth" to "出生地",
    "eu_personal_id_attribute_country_of_birth" to "出生国",
    "eu_personal_id_attribute_date_of_birth" to "生年月日",
    "eu_personal_id_attribute_date_of_expiry" to "有効期限",
    "eu_personal_id_attribute_date_of_issue" to "発行日",
    "eu_personal_id_attribute_document_number" to "文書番号",
    "eu_personal_id_attribute_email_address_of_holder" to "本人のメールアドレス",
    "eu_personal_id_attribute_family_name" to "姓",
    "eu_personal_id_attribute_family_name_at_birth" to "出生時姓",
    "eu_personal_id_attribute_first_name_at_birth" to "出生時名",
    "eu_personal_id_attribute_given_names" to "名",
    "eu_personal_id_attribute_issuing_authority" to "発行機関",
    "eu_personal_id_attribute_issuing_country" to "発行国",
    "eu_personal_id_attribute_issuing_jurisdiction" to "発行管轄",
    "eu_personal_id_attribute_mobile_phone_of_holder" to "保持者の携帯電話",
    "eu_personal_id_attribute_nationality" to "国籍",
    "eu_personal_id_attribute_older_than_18" to "18歳以上",
    "eu_personal_id_attribute_older_than_21" to "21歳以上",
    "eu_personal_id_attribute_older_than_age_attestations" to "年齢に関する宣誓",
    "eu_personal_id_attribute_personal_administrative_number" to "個人識別番号",
    "eu_personal_id_attribute_photo_of_holder" to "本人の写真",
    "eu_personal_id_attribute_place_of_birth" to "出生地",
    "eu_personal_id_attribute_resident_address" to "居住地住所",
    "eu_personal_id_attribute_resident_city" to "居住市",
    "eu_personal_id_attribute_resident_country" to "居住国",
    "eu_personal_id_attribute_resident_house_number" to "居住番地",
    "eu_personal_id_attribute_resident_postal_code" to "居住郵便番号",
    "eu_personal_id_attribute_resident_state" to "居住州",
    "eu_personal_id_attribute_resident_street" to "居住通り",
    "eu_personal_id_attribute_sex" to "性別",
    "eu_personal_id_attribute_state_of_birth" to "出生州",
    "eu_personal_id_attribute_year_of_birth" to "生年",
    "eu_personal_id_description_address" to "住所",
    "eu_personal_id_description_age_in_years" to "PID保持者の年齢（年）",
    "eu_personal_id_description_city_of_birth" to "PIDユーザーの出生地（市町村、都市、町、または村）",
    "eu_personal_id_description_country_of_birth" to "PIDユーザーの出生国（ISO 3166-1で指定されたAlpha-2国コード）",
    "eu_personal_id_description_date_of_birth" to "PID保持者が生まれた日、月、年。不明な場合は、おおよその生年月日。",
    "eu_personal_id_description_date_of_expiry" to "PIDの有効期限が切れる日付（および時間）。",
    "eu_personal_id_description_date_of_issue" to "PIDが発行された日付（および時間）。",
    "eu_personal_id_description_document_number" to "PIDプロバイダーによって割り当てられたPIDの番号。",
    "eu_personal_id_description_email_address_of_holder" to "[RFC 5322]に準拠した、個人識別データが関連するユーザーの電子メールアドレス。",
    "eu_personal_id_description_family_name" to "PID保持者の現在の姓、苗字、または主たる識別子",
    "eu_personal_id_description_family_name_at_birth" to "出生時のPID保持者の姓、または主要な識別子",
    "eu_personal_id_description_first_name_at_birth" to "出生時のPID保持者の名、その他の名前、または副次的な識別子",
    "eu_personal_id_description_given_names" to "PID保持者の現在の名、その他の名、または副次的な識別子",
    "eu_personal_id_description_issuing_authority" to "このPIDインスタンスを発行した行政機関の名称、またはPID発行権限を持つ独立機関がない場合は、該当する加盟国のISO 3166 Alpha-2国コード。",
    "eu_personal_id_description_issuing_country" to "ISO 3166-1で定義されている、発行機関の国または地域のAlpha-2国コード。",
    "eu_personal_id_description_issuing_jurisdiction" to "ISO 3166-2:2020、Clause 8で定義されている、PIDを発行した管轄区域の国細分化コード。コードの最初の部分は、発行国（issuing_country）の値と同じでなければなりません。",
    "eu_personal_id_description_mobile_phone_of_holder" to "個人識別データが関連するユーザーの携帯電話番号。国際コードプレフィックスとして「+」記号と国コードで始まり、その後に数字のみが続きます。",
    "eu_personal_id_description_nationality" to "ISO 3166-1で指定されているAlpha-2国コードで示される、PID利用者の国籍。",
    "eu_personal_id_description_older_than_18" to "18歳以上ですか？",
    "eu_personal_id_description_older_than_21" to "21歳以上ですか？",
    "eu_personal_id_description_older_than_age_attestations" to "特定年齢以上であることの証明",
    "eu_personal_id_description_personal_administrative_number" to "監査管理またはその他の目的のためにPIDプロバイダーによって割り当てられた番号。",
    "eu_personal_id_description_photo_of_holder" to "PID保持者の顔写真の複製。",
    "eu_personal_id_description_place_of_birth" to "PID保持者の出生国と市町村、または州/県",
    "eu_personal_id_description_resident_address" to "PID保有者の現住所、または連絡先住所（番地、市区町村など）。",
    "eu_personal_id_description_resident_city" to "PID保有者が現在居住している都市。",
    "eu_personal_id_description_resident_country" to "PID利用者が現在居住している国を、ISO 3166-1で指定されているAlpha-2国コードで示します。",
    "eu_personal_id_description_resident_house_number" to "PID利用者が現在居住している番地（接頭辞または接尾辞を含む）。",
    "eu_personal_id_description_resident_postal_code" to "PID保有者が現在居住している場所の郵便番号。",
    "eu_personal_id_description_resident_state" to "PID利用者が現在居住している州、県、地区、または地方。",
    "eu_personal_id_description_resident_street" to "PID利用者が現在居住している通りの名前。",
    "eu_personal_id_description_sex" to "PID保有者の性別",
    "eu_personal_id_description_state_of_birth" to "PIDユーザーの出生地（州、県、地区、または地方）",
    "eu_personal_id_description_year_of_birth" to "本人が生まれた年",
    "eu_personal_id_request_age_over_18" to "18歳以上",
    "eu_personal_id_request_age_over_18_and_portrait" to "18歳以上 + 顔写真",
    "eu_personal_id_request_age_over_18_and_portrait_equivalence" to "18歳以上 + 顔写真同等物",
    "eu_personal_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "18歳以上 + (顔写真 または 顔写真同等物)",
    "eu_personal_id_request_age_over_18_zkp" to "18歳以上 (ZKP)",
    "eu_personal_id_request_all_data_elements" to "全てのデータ要素",
    "eu_personal_id_request_mandatory_data_elements" to "必須データ要素",
    "eu_personal_id_request_name_and_portrait" to "氏名 + 顔写真",
    "eu_personal_id_request_name_and_portrait_equivalence" to "氏名 + 顔写真同等物",
    "eu_personal_id_request_name_and_portrait_or_portrait_equivalence" to "氏名 + (顔写真 または 顔写真同等物)",
    "id_pass_request_age_over_18" to "18歳以上",
    "id_pass_request_age_over_18_and_portrait" to "18歳以上 + 顔写真",
    "id_pass_request_age_over_18_and_portrait_equivalence" to "18歳以上 + 顔写真同等物",
    "id_pass_request_age_over_18_and_portrait_or_portrait_equivalence" to "18歳以上＋（顔写真または顔写真に相当するもの）",
    "id_pass_request_age_over_18_zkp" to "18歳以上 (ZKP)",
    "id_pass_request_age_over_21" to "21歳以上",
    "id_pass_request_age_over_21_and_portrait" to "21歳以上 + 顔写真",
    "id_pass_request_age_over_21_zkp" to "21歳以上 (ZKP)",
    "id_pass_request_all_data_elements" to "全データ項目",
    "id_pass_request_mandatory_data_elements" to "必須データ項目",
    "multi_request_age_over_18_mdl_or_pid" to "mDLまたはPIDによる18歳以上の確認 + 取引",
    "multi_request_mdl_and_photoid" to "mDLおよび顔写真付きID",
    "multi_request_mdl_or_photoid" to "mDLまたは顔写真付きID",
    "multi_request_payment_and_age_over_18" to "支払いと18歳以上",
    "photo_id_attribute_administrative_number" to "管理番号",
    "photo_id_attribute_age_in_years" to "年齢",
    "photo_id_attribute_birth_city" to "出生地",
    "photo_id_attribute_birth_country" to "出生国",
    "photo_id_attribute_birth_state" to "出生州",
    "photo_id_attribute_date_of_birth" to "生年月日",
    "photo_id_attribute_date_of_expiry" to "有効期限",
    "photo_id_attribute_date_of_issue" to "発行日",
    "photo_id_attribute_document_number" to "文書番号",
    "photo_id_attribute_dtc_vc_version" to "DTC-VCバージョン",
    "photo_id_attribute_emrtd_dg1" to "eMRTD DG1",
    "photo_id_attribute_emrtd_dg10" to "eMRTD DG10",
    "photo_id_attribute_emrtd_dg11" to "eMRTD DG11",
    "photo_id_attribute_emrtd_dg12" to "eMRTD DG12",
    "photo_id_attribute_emrtd_dg13" to "eMRTD DG13",
    "photo_id_attribute_emrtd_dg14" to "eMRTD DG14",
    "photo_id_attribute_emrtd_dg15" to "eMRTD DG15",
    "photo_id_attribute_emrtd_dg16" to "eMRTD DG16",
    "photo_id_attribute_emrtd_dg2" to "eMRTD DG2",
    "photo_id_attribute_emrtd_dg3" to "eMRTD DG3",
    "photo_id_attribute_emrtd_dg4" to "eMRTD DG4",
    "photo_id_attribute_emrtd_dg5" to "eMRTD DG5",
    "photo_id_attribute_emrtd_dg6" to "eMRTD DG6",
    "photo_id_attribute_emrtd_dg7" to "eMRTD DG7",
    "photo_id_attribute_emrtd_dg8" to "eMRTD DG8",
    "photo_id_attribute_emrtd_dg9" to "eMRTD DG9",
    "photo_id_attribute_emrtd_sod" to "eMRTD SOD",
    "photo_id_attribute_family_name" to "姓",
    "photo_id_attribute_family_name_latin1" to "姓",
    "photo_id_attribute_family_name_viz" to "姓 (VIZ)",
    "photo_id_attribute_given_name_viz" to "名 (VIZ)",
    "photo_id_attribute_given_names" to "名",
    "photo_id_attribute_given_names_latin1" to "名",
    "photo_id_attribute_issuing_authority" to "発行機関",
    "photo_id_attribute_issuing_country" to "発行国",
    "photo_id_attribute_issuing_subdivision" to "発行部局",
    "photo_id_attribute_name_at_birth" to "出生時の氏名",
    "photo_id_attribute_nationality" to "国籍",
    "photo_id_attribute_person_id" to "個人ID",
    "photo_id_attribute_photo_of_holder" to "顔写真",
    "photo_id_attribute_place_of_birth" to "出生地",
    "photo_id_attribute_portrait_capture_date" to "顔写真撮影日",
    "photo_id_attribute_resident_address" to "居住住所",
    "photo_id_attribute_resident_city" to "居住市",
    "photo_id_attribute_resident_city_latin1" to "居住都市",
    "photo_id_attribute_resident_country" to "居住国",
    "photo_id_attribute_resident_house_number" to "居住地号数",
    "photo_id_attribute_resident_postal_code" to "居住郵便番号",
    "photo_id_attribute_resident_state" to "居住地州",
    "photo_id_attribute_resident_street" to "居住地番地",
    "photo_id_attribute_sex" to "性別",
    "photo_id_attribute_travel_document_mrz" to "渡航書類MRZ",
    "photo_id_attribute_travel_document_number" to "渡航書類番号",
    "photo_id_attribute_travel_document_type" to "渡航書類の種類",
    "photo_id_attribute_year_of_birth" to "生年",
    "photo_id_description_administrative_number" to "顔写真付きID発行者が監査管理などの目的で割り当てた番号。",
    "photo_id_description_age_in_years" to "書類保持者の年齢",
    "photo_id_description_birth_city" to "顔写真付きID所持者の出生地（市区町村）。",
    "photo_id_description_birth_country" to "写真付き身分証明書所持者の出生国。ISO 3166-1で指定されたAlpha-2国コード",
    "photo_id_description_birth_state" to "写真付き身分証明書所持者が生まれた州、県、地区、または地方",
    "photo_id_description_date_of_birth" to "書類所有者の生年月日。不明な場合はおおよその生年月日",
    "photo_id_description_date_of_expiry" to "書類の有効期限",
    "photo_id_description_date_of_issue" to "書類の発行日",
    "photo_id_description_document_number" to "発行機関によって割り当てまたは計算された番号",
    "photo_id_description_dtc_vc_version" to "DTC-VC定義のバージョン。",
    "photo_id_description_emrtd_dg1" to "データグループ1：個人情報データ（MRZに記録されたデータ）",
    "photo_id_description_emrtd_dg10" to "データグループ10：物質特性",
    "photo_id_description_emrtd_dg11" to "データグループ11：追加の個人情報",
    "photo_id_description_emrtd_dg12" to "データグループ12：追加の書類情報",
    "photo_id_description_emrtd_dg13" to "データグループ13：オプション情報",
    "photo_id_description_emrtd_dg14" to "データグループ14：セキュリティオプション",
    "photo_id_description_emrtd_dg15" to "データグループ15：アクティブ認証公開鍵情報",
    "photo_id_description_emrtd_dg16" to "データグループ16：通知対象者",
    "photo_id_description_emrtd_dg2" to "データグループ2：参照顔画像（符号化された顔）",
    "photo_id_description_emrtd_dg3" to "データグループ3：符号化された指紋",
    "photo_id_description_emrtd_dg4" to "データグループ4：符号化された眼",
    "photo_id_description_emrtd_dg5" to "データグループ5：表示肖像",
    "photo_id_description_emrtd_dg6" to "データグループ6：将来利用のために予約済み",
    "photo_id_description_emrtd_dg7" to "データグループ7：表示される署名または慣用印",
    "photo_id_description_emrtd_dg8" to "データグループ8：データ特性",
    "photo_id_description_emrtd_dg9" to "データグループ9：構造特性",
    "photo_id_description_emrtd_sod" to "eMRTD文書セキュリティオブジェクトのバイナリデータ。",
    "photo_id_description_family_name" to "書類所有者の姓、名字、または主要識別子",
    "photo_id_description_family_name_latin1" to "書類所持者の姓、名字、または主要識別子",
    "photo_id_description_family_name_viz" to "ICAO 9303のVIZ（目視検査領域）で定義されている姓",
    "photo_id_description_given_name_viz" to "ICAO 9303のVIZ（目視検査領域）で定義されている名",
    "photo_id_description_given_names" to "書類所有者の名、その他の名、または補助識別子",
    "photo_id_description_given_names_latin1" to "書類所持者の名、その他の名前、または副次的識別子",
    "photo_id_description_issuing_authority" to "発行機関名",
    "photo_id_description_issuing_country" to "発行機関の国または地域を示す、ISO 3166-1で定義されたアルファベット2文字の国コード",
    "photo_id_description_issuing_subdivision" to "モバイルeID書類を発行した、または発行機関が所在するISO 3166-2で定義された下位区分コード",
    "photo_id_description_name_at_birth" to "書類保持者の出生時の氏名",
    "photo_id_description_nationality" to "書類所持者の国籍",
    "photo_id_description_person_id" to "写真付き身分証明書所持者の個人識別子",
    "photo_id_description_photo_of_holder" to "書類所有者の肖像の複製",
    "photo_id_description_place_of_birth" to "書類保持者が生まれた国、市町村、または州/県",
    "photo_id_description_portrait_capture_date" to "顔写真の撮影日",
    "photo_id_description_resident_address" to "書類保持者の居住地および連絡先（番地、市町村など）",
    "photo_id_description_resident_city" to "書類保持者の居住地の市/区町村（またはそれに相当するもの）",
    "photo_id_description_resident_city_latin1" to "所持者が居住する都市/地方自治体（または同等の地域）",
    "photo_id_description_resident_country" to "書類保持者の居住国",
    "photo_id_description_resident_house_number" to "顔写真付きID所持者が現在居住している番地（接頭辞や接尾辞を含む）。",
    "photo_id_description_resident_postal_code" to "書類保持者の郵便番号",
    "photo_id_description_resident_state" to "顔写真付きID所持者が居住している州、都道府県、地区。",
    "photo_id_description_resident_street" to "顔写真付きID所持者が現在居住している通りの名前。",
    "photo_id_description_sex" to "書類所持者の性別",
    "photo_id_description_travel_document_mrz" to "物理的な書類に印字されている、機械読取可能ゾーンのテキスト。",
    "photo_id_description_travel_document_number" to "顔写真付きIDが紐付けられている渡航文書の番号（渡航文書に紐付けられている、または渡航文書から派生している場合）。",
    "photo_id_description_travel_document_type" to "元となる書類の種別を示すもの（渡航文書に紐付いている、または渡航文書から派生している場合）。",
    "photo_id_description_year_of_birth" to "書類保持者の生年",
    "photo_id_request_age_over_18" to "18歳以上",
    "photo_id_request_age_over_18_and_portrait" to "18歳以上 + 顔写真",
    "photo_id_request_age_over_18_and_portrait_equivalence" to "18歳以上 + 顔写真同等物",
    "photo_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "18歳以上 + (顔写真 または 顔写真同等物)",
    "photo_id_request_age_over_18_zkp" to "18歳以上 (ZKP)",
    "photo_id_request_all_data_elements" to "すべてのデータ項目",
    "photo_id_request_mandatory_data_elements" to "必須データ要素",
    "vaccination_attribute_birth_day" to "誕生日",
    "vaccination_attribute_birth_month" to "誕生月",
    "vaccination_attribute_birth_year" to "生年",
    "vaccination_attribute_covid19_first_vaccination" to "RA01 初回接種",
    "vaccination_attribute_covid19_second_vaccination" to "RA01 2回目接種",
    "vaccination_attribute_covid19_test" to "COVID-19検査イベント",
    "vaccination_attribute_covid19_vaccinated" to "COVID-19の予防接種",
    "vaccination_attribute_date_of_birth" to "生年月日",
    "vaccination_attribute_facial_image" to "顔画像",
    "vaccination_attribute_family_name" to "姓",
    "vaccination_attribute_family_name_initial" to "姓イニシャル",
    "vaccination_attribute_given_name" to "名",
    "vaccination_attribute_given_name_initial" to "名イニシャル",
    "vaccination_attribute_id_with_drivers_license_number" to "運転免許証番号付きID",
    "vaccination_attribute_id_with_passport_number" to "パスポート番号付きID",
    "vaccination_attribute_safe_entry_leisure" to "セーフエントリー表示",
    "vaccination_attribute_sex" to "性別",
    "vaccination_attribute_yellow_fever_vaccinated" to "黄熱病の予防接種",
    "vaccination_description_birth_day" to "保持者の誕生日",
    "vaccination_description_birth_month" to "保持者の生月",
    "vaccination_description_birth_year" to "保持者の生年",
    "vaccination_description_covid19_first_vaccination" to "COVID-19 - 初回接種データ",
    "vaccination_description_covid19_second_vaccination" to "COVID-19 - 2回目接種データ",
    "vaccination_description_covid19_test" to "COVID-19陰性検査証明",
    "vaccination_description_covid19_vaccinated" to "COVID-19ワクチン完全接種証明",
    "vaccination_description_date_of_birth" to "保持者の生年月日",
    "vaccination_description_facial_image" to "保持者の顔写真",
    "vaccination_description_family_name" to "保持者の姓",
    "vaccination_description_family_name_initial" to "保持者の姓の頭文字",
    "vaccination_description_given_name" to "保持者の名",
    "vaccination_description_given_name_initial" to "保持者の名の頭文字",
    "vaccination_description_id_with_drivers_license_number" to "運転免許証番号による所有者識別のための固有要素",
    "vaccination_description_id_with_passport_number" to "パスポート番号による所有者識別のための固有要素",
    "vaccination_description_safe_entry_leisure" to "レジャー目的の安全な入場要件証明",
    "vaccination_description_sex" to "性別",
    "vaccination_description_yellow_fever_vaccinated" to "黄熱病ワクチン完全接種証明",
    "vehicle_registration_attribute_basic_vehicle_info" to "基本車両情報",
    "vehicle_registration_attribute_issue_date" to "発行日",
    "vehicle_registration_attribute_registration_holder" to "車両登録名義人情報",
    "vehicle_registration_attribute_registration_info" to "車両登録情報",
    "vehicle_registration_attribute_vin" to "車両識別番号",
    "vehicle_registration_description_basic_vehicle_info" to "このデータ要素には、基本的な車両情報が含まれます。",
    "vehicle_registration_description_issue_date" to "書類の発行日",
    "vehicle_registration_description_registration_holder" to "このデータ要素は、登録証明書の保有者を特定します。",
    "vehicle_registration_description_registration_info" to "このデータ要素には、UN/EU要素のAおよびHを含む、一般的な車両登録情報が含まれます。",
    "vehicle_registration_description_vin" to "車両メーカーによって定められた車両識別番号"
)
